module.exports = __webpack_public_path__ + "static/023.thumb-76746c990cb48e485558b1ff4db73276.jpg";